<dialog-header
  title="Create Customer"
  (onClose)="matDialogRef.close()"
></dialog-header>

<div
  mat-dialog-content
  style="
    border-top: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
    background-color: var(--app-container);
  "
>
  <form [formGroup]="form" style="margin-top: 20px">
    <div class="form-field">
      <div class="form-field-label">
        Customer Name<span style="color: red">*</span>
      </div>
      <input
        class="form-input"
        autocomplete="off"
        [formControl]="nameFormControl"
        type="text"
        placeholder="Enter customer name"
      />
    </div>

    <div class="form-field" style="margin-top: 20px">
      <div class="form-field-label">Email Address (Optional)</div>
      <input
        class="form-input"
        autocomplete="off"
        [formControl]="emailFormControl"
        type="email"
        placeholder="Enter email address"
      />
      <div style="font-size: 12px; color: gray; margin-top: 5px">
        If the customer creates an account later, they will be automatically
        linked
      </div>
    </div>

    <div class="form-field" style="margin-top: 20px">
      <single-select
        label="Card"
        [formCtrl]="cardFormControl"
        [value]="cardFormControl.value"
        [options]="cards"
        [inBrackets]="'displayDescription'"
        property="displayTitle"
        [showIcon]="false"
        [showSearch]="true"
      ></single-select>
      <div style="font-size: 12px; color: gray; margin-top: 5px">
        Select a card to give the customer when they are created
      </div>
    </div>
  </form>
</div>

<div mat-dialog-actions align="end">
  <app-secondary-button
    style="margin-right: 10px"
    [title]="'Cancel'"
    [disabled]="false"
    (tapped)="matDialogRef.close()"
  ></app-secondary-button>

  <app-primary-button
    [title]="'Create'"
    [disabled]="saving || form.invalid"
    (tapped)="createCustomer()"
    bgColor="var(--app-timber)"
    color="white"
  ></app-primary-button>
</div>

<loader [loading]="saving"></loader>
